import React, { useState } from 'react';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import ContentCopyIcon from 'mdi-react/ContentCopyIcon';

const ApiKeyRevealModal = ({ modal, toggle, apiKey, title }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey || '').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      modalClassName="ltr-support"
      className="modal-dialog modal-dialog--primary theme-light"
    >
      <div className="modal__header">
        <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
      </div>
      <div className="modal__body">
        <p className="bold-text">{title || 'API key generated'}</p>
        <p>Copy this key now — for security reasons it won’t be shown in full again.</p>
        <div
          style={{
            background: '#f2f4f7',
            padding: '10px 12px',
            borderRadius: '4px',
            wordBreak: 'break-all',
            fontFamily: 'monospace',
            marginTop: '10px',
          }}
        >
          {apiKey}
        </div>
      </div>
      <ButtonToolbar className="modal__footer">
        <Button className="modal_ok" color="primary" onClick={handleCopy}>
          <ContentCopyIcon size={16} style={{ marginRight: '5px' }} />
          {copied ? 'Copied!' : 'Copy key'}
        </Button>
        <Button className="modal_cancel" onClick={toggle}>Close</Button>
      </ButtonToolbar>
    </Modal>
  );
};

export default ApiKeyRevealModal;
